import {
  SET_ACTIVE_PROGRAM_DETAILS,
  SET_ALL_PROGRAM_DETAILS,
} from '../constants';

const initialState = {
  activeProgram: {},
  allPrograms: [],
};

export const programReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_PROGRAM_DETAILS:
      return {
        ...state,
        activeProgram: {
          ...state.activeProgram,
          ...action.payload,
        },
      };
    case SET_ALL_PROGRAM_DETAILS:
      return {
        ...state,
        allPrograms: action.payload,
      };
    default:
      return state;
  }
};
